import { Department, ArticleStatus, Role, ProductCardStatus } from "../main/schemas";

export const roleHierarchy: { [key in Role]: Role[] } = {
  DEVELOPER: ["DREADNOUGHT", "CEO", "BOSS", "MANAGER", "EMPLOYEE", "NOOB"],
  DREADNOUGHT: ["CEO", "BOSS", "MANAGER", "EMPLOYEE", "NOOB"],
  CEO: ["BOSS", "MANAGER", "EMPLOYEE", "NOOB"],
  BOSS: ["MANAGER", "EMPLOYEE", "NOOB"],
  MANAGER: ["EMPLOYEE", "NOOB"],
  EMPLOYEE: ["NOOB"],
  NOOB: [],
};

export const roleMap: { [key in Role]: string } = {
  DREADNOUGHT: "Демиург",
  CEO: "Генеральный директор",
  BOSS: "Руководитель",
  MANAGER: "Менеджер",
  EMPLOYEE: "Сотрудник",
  NOOB: "Новичок",
  DEVELOPER: "Разработчик",
};
export const departmentMap: { [key in Department]: string } = {
  HR: "HR",
  PRODUCT: "Продукт",
  COMMERS: "Коммерция",
  MARKETING: "Маркетинг",
  FINANCE: "Финансы",
  LOGISTIC: "Логистика",
  ANALYTIC: "Аналитика",
  FATHERS: "Разработчики",
  NOOB: "Новички",
};

export const ProductCardStatusMap: {
  [key in ProductCardStatus]: { value: string; color: string };
} = {
  Запуск: { value: "Запуск", color: "bg-green-500" },
  "Стратегия демпинга": { value: "Демпинг", color: "bg-destructive" },
  Ключевой: { value: "Ключевой", color: "bg-green-700" },
  Перезапуск: { value: "Перезапуск", color: "bg-cyan-600" },
  FBS: { value: "FBS", color: "bg-lime-400" },
  "СТОП отгрузка!": { value: "СТОП", color: "bg-violet-300" },
  Распродаем: { value: "Распродаем", color: "bg-amber-500" },
  Архив: { value: "Архив", color: "bg-zinc-400" },
  "Дешевый выкуп": { value: "Выкуп", color: "bg-zinc-400" },
  "Для индексации цен": { value: "Индексация", color: "bg-zinc-400" },
  "не в АМ": { value: "Другой", color: "bg-zinc-400" },
};

export const getHumanReadableProductCardStatus = (status: ProductCardStatus) => {
  return ProductCardStatusMap[status] || { value: "Неизвестный", color: "bg-destructive" };
};

export const StatusMap: {
  [key in ArticleStatus]: { value: string; color: string };
} = {
  Ликвид: { value: "Ликвидный", color: "bg-green-500" },
  Неликвид: { value: "Не ликвидный", color: "bg-destructive" },
  Вывод: { value: "Вывод", color: "bg-amber-500" },
  Новый: { value: "Новый", color: "bg-cyan-600" },
  Архив: { value: "Архив", color: "bg-zinc-400" },
  Перезапуск: { value: "Перезапуск", color: "bg-cyan-600" },
};

export const getHumanReadableStatus = (status: ArticleStatus) => {
  return StatusMap[status] || { value: "Неизвестный", color: "bg-destructive" };
};

export function getHumanReadableDepartment(department: Department): string {
  return departmentMap[department];
}
export function getHumanReadableRole(role: Role): string {
  return roleMap[role];
}

export function getAvailableRoles(currentRole: Role): Role[] {
  return roleHierarchy[currentRole];
}

export const planFulfillmentColor = (fact: number, plan: number): string =>
  Math.floor(fact) >= Math.floor(plan) ? "text-success" : "text-destructive";
